(function () {
	'use strict';
	angular.module('app.setup')
		.controller('cloneMetrics', cloneMetrics);

	cloneMetrics.$inject = ['$scope', '$timeout'];

	function cloneMetrics($scope, $timeout) {
		var vm = this;
		var tabIndex = {
			'plant': 0,
			'valuestreams': 1
		};
		vm.activeTab = 'plant';
		vm.activeTabIndex = 0;
		vm.selectTab = selectTab;

		function selectTab($tab) {
			vm.activeTab = $tab;
			vm.activeTabIndex = tabIndex[$tab];
		}
	}

})();
